import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaTimes, FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from "sweetalert2";
import UserService from "../services/UserService";
import LoadingSpinner from '../utils/LoadingSpinner';

const ResetPasswordPage2 = () => {
    const [code, setCode] = useState("");
    const [error, setError] = useState("");
    const [formData, setFormData] = useState({
        password: "",
        confirmPassword: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isTokenValidated, setIsTokenValidated] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(true);
    const [touched, setTouched] = useState({
        password: false,
        confirmPassword: false
    });
    const navigate = useNavigate();

    useEffect(() => {
        const startTime = Date.now();

        const loadData = async () => {
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, 2000 - elapsedTime);

            if (remainingTime > 0) {
                await new Promise(resolve => setTimeout(resolve, remainingTime));
            }

            setIsPageLoading(false);
        };

        loadData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        if (error) setError("");
    };

    const handleBlur = (field) => {
        setTouched({...touched, [field]: true});
    };

    const handleCloseError = () => {
        setError("");
    };

    const handleTokenSubmit = async (e) => {
        e.preventDefault();
        if (!code) {
            setError("Veuillez saisir le code de vérification");
            return;
        }
        setLoading(true);
        try {
            const response = await UserService.verifyEmail(code, "fr");
            setUserInfo(response);
            setIsTokenValidated(true);
        } catch (err) {
            setError(err.response?.data?.message || "Le code est invalide. Veuillez réessayer.");
        } finally {
            setLoading(false);
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();

        // Activer les validations pour tous les champs
        setTouched({
            password: true,
            confirmPassword: true
        });

        // Validation des champs
        if (formData.password.length < 6) {
            setError("Le mot de passe doit contenir au moins 6 caractères.");
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            setError("Les mots de passe ne correspondent pas.");
            return;
        }

        setLoading(true);
        try {
            const reInitPasswordRequestDTO = {
                password: formData.password,
                passwordConfirmation: formData.confirmPassword,
                username: userInfo.username,
            };
            await UserService.reinitializePassword(reInitPasswordRequestDTO, "fr");

            Swal.fire({
                icon: "success",
                title: "Succès",
                text: "Votre mot de passe a été modifié avec succès.",
                confirmButtonText: "OK",
            }).then(() => {
                navigate("/login");
            });
        } catch (err) {
            setError(err.response?.data?.message || "Une erreur est survenue. Veuillez réessayer.");
        } finally {
            setLoading(false);
        }
    };

    if (isPageLoading) {
        return <LoadingSpinner isVisible={true} loadingText="Chargement..." />;
    }

    return (
        <div className="d-flex flex-column vh-100">
            <div className="flex-grow-1 overflow-y-scroll">
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    maxWidth: '600px',
                    margin: '0 auto'
                }}>
                    <div className="verify-number-main" style={{
                        marginTop: "10%",
                        borderRadius: '5%',
                        width: '100%',
                        maxWidth: '100%'
                    }}>
                        <div className="verify-number-top">
                            <div className="container">
                                <Link to="/">
                                    <div className="text-center">
                                        <img
                                            src="assets/images/logo/logo.png"
                                            alt="Logo NTR Finance"
                                            style={{width: "150px", marginBottom: "20px", borderRadius: "50%", marginTop: "20px"}}
                                        />
                                        <h1
                                            className="app-name"
                                            style={{
                                                fontSize: "24px",
                                                fontWeight: "bold",
                                                margin: "10px 0",
                                                color: "#fff",
                                            }}
                                        >
                                            NTR Finance
                                        </h1>
                                        <div className="header-title">
                                            <p>{isTokenValidated ? "Modifier le mot de passe" : "Vérification du code"}</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>

                        <div className="verify-number-bottom" style={{
                            borderBottomLeftRadius: '5%',
                            borderBottomRightRadius: '5%',
                            minHeight: '10%'
                        }}>
                            <div className="verify-number-bottom-wrap">
                                <form id="msform" onSubmit={isTokenValidated ? handlePasswordSubmit : handleTokenSubmit}>
                                    {error && (
                                        <div
                                            className="alert alert-danger d-flex justify-content-between align-items-center"
                                            role="alert">
                                            <span>{error}</span>
                                            <button type="button" className="btn-close" onClick={handleCloseError}>
                                                <FaTimes/>
                                            </button>
                                        </div>
                                    )}

                                    {!isTokenValidated ? (
                                        <div className="multistep-form">
                                            <div className="form-floating mt-24">
                                                <input
                                                    type="text"
                                                    name="code"
                                                    value={code}
                                                    onChange={(e) => setCode(e.target.value)}
                                                    className={`form-control ${error ? "is-invalid" : ""}`}
                                                    placeholder="Code de vérification"
                                                    autoComplete="off"
                                                    required
                                                />
                                                <label>Code de vérification</label>
                                                {error && <div className="invalid-feedback">{error}</div>}
                                            </div>

                                            <div className="mt-4">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary w-100"
                                                    disabled={loading}
                                                >
                                                    {loading ? "Vérification en cours..." : "Vérifier le code"}
                                                </button>
                                            </div>

                                            <div className="mt-32 text-center"
                                                 style={{
                                                     fontSize: '20px',
                                                     fontWeight: 'bold',
                                                     paddingBottom: '50px',
                                                 }}
                                            >
                                                <span>Vous n'avez pas reçu le code ? </span>
                                                <Link to="/reset-password1" className="text-decoration-none">
                                                    Renvoyer le code
                                                </Link>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="multistep-form">
                                            <div className="form-floating mt-24 position-relative">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    name="password"
                                                    value={formData.password}
                                                    onChange={handleChange}
                                                    onBlur={() => handleBlur('password')}
                                                    className={`form-control ${
                                                        touched.password && formData.password.length < 6 ? "is-invalid" : ""
                                                    }`}
                                                    placeholder="Nouveau mot de passe"
                                                    autoComplete="off"
                                                    required
                                                />
                                                <label>Nouveau mot de passe</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-link position-absolute end-0 translate-middle-y"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    style={{
                                                        zIndex: 5,
                                                        background: "none",
                                                        border: "none",
                                                        padding: "0.375rem 0.75rem",
                                                        top: "40%",
                                                        paddingRight: "30px",
                                                        fontSize: "35px",
                                                    }}
                                                >
                                                    {showPassword ? <FaEyeSlash/> : <FaEye/>}
                                                </button>
                                                {touched.password && formData.password.length < 6 && (
                                                    <div className="invalid-feedback">
                                                        Le mot de passe doit contenir au moins 6 caractères.
                                                    </div>
                                                )}
                                            </div>

                                            <div className="form-floating mt-24 position-relative">
                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    name="confirmPassword"
                                                    value={formData.confirmPassword}
                                                    onChange={handleChange}
                                                    onBlur={() => handleBlur('confirmPassword')}
                                                    className={`form-control ${
                                                        touched.confirmPassword && formData.confirmPassword !== formData.password ? "is-invalid" : ""
                                                    }`}
                                                    placeholder="Confirmer le mot de passe"
                                                    autoComplete="off"
                                                    required
                                                />
                                                <label>Confirmer le mot de passe</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-link position-absolute end-0 translate-middle-y"
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                    style={{
                                                        zIndex: 5,
                                                        background: "none",
                                                        border: "none",
                                                        padding: "0.375rem 0.75rem",
                                                        top: "40%",
                                                        paddingRight: "30px",
                                                        fontSize: "35px",
                                                    }}
                                                >
                                                    {showConfirmPassword ? <FaEyeSlash/> : <FaEye/>}
                                                </button>
                                                {touched.confirmPassword && formData.confirmPassword !== formData.password && (
                                                    <div className="invalid-feedback">
                                                        Les mots de passe ne correspondent pas.
                                                    </div>
                                                )}
                                            </div>

                                            <div className="mt-4">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary w-100"
                                                    disabled={loading}
                                                >
                                                    {loading ? "Enregistrement en cours..." : "Enregistrer le nouveau mot de passe"}
                                                </button>
                                            </div>

                                            <div className="mt-32 text-center"
                                                 style={{
                                                     fontSize: '20px',
                                                     fontWeight: 'bold',
                                                     paddingBottom: '50px',
                                                 }}
                                            >
                                                <span>Retourner à la </span>
                                                <Link to="/login" className="text-decoration-none">
                                                    Connexion
                                                </Link>
                                            </div>
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage2;